import { render, staticRenderFns } from "./office-city.vue?vue&type=template&id=ba3126aa&"
import script from "./office-city.vue?vue&type=script&lang=js&"
export * from "./office-city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports